import React from 'react';
import "../components/style_v2.css"
import "../components/style.css";
import Navbar from '../components/Navbar';
import Carousel from '../components/home/home_Carousel';
import Partners from '../components/home/home_Partners';
import StrategyGenie from '../components/home/home_StrategyGenie';
import SolutionSection from '../components/home/home_SolutionSection';
import CoreFeatures from '../components/home/home_CoreFeatures';
import PricingPlans from '../components/home/home_PricingPlans';
import Services from '../components/home/home_Services';
import StrategyInquiry from '../components/home/home_StrategyInquiry';
import Kpi from '../components/home/home_KPI';
import SecurityFeatures from '../components/home/home_SecurityFeatures';
import Outsourcing from '../components/home/home_Outsourcing';
import AiProjectsSectionVideo from "../components/product_ai/AiProjectsSectionVideo";
import Topbar from '../components/Topbar';
import { Init } from '../components/language/home/home_About_lang';
const LANGUAGE = Init(navigator.language);


const Page = () => {
  return (
    <div>
      <Topbar />
      <Navbar />
      <Carousel />
      <StrategyGenie />
      <AiProjectsSectionVideo />
      <Partners />
      <SolutionSection />
      <CoreFeatures />
      <SecurityFeatures />
      {/* <PricingPlans /> */}
      <Outsourcing />
      {/* <Kpi /> */}
      {/* <StrategyInquiry /> */}
    </div>
  );
};

export default Page;